import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import OverlayManager from 'OverlayManager';
import { SVGIcon } from '@pearsontechnology/aero-components-learnspace';

const Wrap = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme['color.overlay.background']};
  opacity:0.5;
  display: none;
  ${({ show }) => show && `
  display: flex;
  `}
`;

const Text = styled.div`
  padding-left: 10px;
`;

const Toast = styled.div`
  display:flex;
  justify-content:center;
  min-width: 260px;
  height: 50px;
  padding: 15px;
  z-index: 1500;
  position: fixed;
  top: 70px;
  left: 50%;
  border-radius: 4px;
  font: normal normal 14px/19px Open Sans;
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  transform: translate(-50%, calc(-100% - 25px));
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0,0,0,0.08), 0 2px 4px 0 rgba(0,0,0,0.16), 0 5px 14px 0 rgba(0,0,0,0.1);
  background-color: ${({ theme }) => theme['color.overlay.toast.background']};
  color: ${({ theme }) => theme['color.overlay.text.toast']};
  @media only screen 
  and (max-width: 765px){
    top:0px;
    width:100vw;
    border-radius: 0px;
    flex-wrap: wrap;
    height:auto;
  }
  ${({ show }) => show && `
    transform: translateX(-50%);
    opacity: 1;
  `}
`;

Toast.displayName = 'OverlayContainerToast';

const OverlayContainer = ({ children }) => {
  const [showOverlay, setShowOverlay] = React.useState(false);

  const onNotify = (message) => {
    setShowOverlay(message.showOverlay);
  };

  useEffect(() => {
    OverlayManager.registerListener(onNotify);
  }, []);

  return (
    <>
      {children}
      <Wrap show={showOverlay}></Wrap>
      {showOverlay && (
        <Toast show={showOverlay}>
          <SVGIcon
            icon="offline"
            viewBox="0 0 24 18"
            size={{ width: '24px', height: '18px' }}
          />
          <Text>Please hold on while we try to reconnect.</Text>
        </Toast>
      )}
    </>
  );
};

OverlayContainer.propTypes = {
  children: PropTypes.any,
};

export default OverlayContainer;
